import { Grid, Group, Stack } from '@mantine/core'
import { Switch, TimeRange } from '@forwardflow/ui-v2'
import { Dispatch, SetStateAction } from 'react'
import cn from 'classnames'
import { MoonIcon, SunIcon } from '@forwardflow/icons'
import { IAvailabilityDay, TDay } from '@forwardflow/types/onboarding'

const DAYS = [
   'Monday',
   'Tuesday',
   'Wednesday',
   'Thursday',
   'Friday',
   'Saturday',
   'Sunday',
]

export const DifferentTime = ({
   selectedDays = [],
   setSelectedDays,
}: {
   selectedDays: IAvailabilityDay[]
   setSelectedDays: Dispatch<
      SetStateAction<IAvailabilityDay[]>
   >
}) => {
   const handleDaySelection = (day: TDay) => {
      setSelectedDays((prev) => {
         return prev.map((d) => {
            if (d.day !== day) return d
            return { ...d, enabled: !d.enabled }
         })
      })
   }

   const handleTimeSelection = (day: TDay, startTime: string, endTime: string) => {
      setSelectedDays((prev) => {
         return prev.map((d) => {
            if (d.day !== day) return d
            return { ...d, startTime, endTime }
         })
      })
   }

   return (
      <Stack gap={0} className="mb-6">
         {DAYS.map((day) => {
            const selectedDay = selectedDays?.find((d) => d.day === day)
            return (
               <Grid
                  key={day}
                  className={cn('py-2 px-8', {
                     'border-b border-white/10': day !== DAYS[DAYS.length - 1],
                  })}
               >
                  <Grid.Col span={3}>
                     <Group gap={8} align="center" className="h-full ">
                        {selectedDay?.enabled ? (
                           <SunIcon width={18} height={18} color="#A684FF" />
                        ) : (
                           <MoonIcon width={18} height={18} color="#4A5565" />
                        )}
                        <p
                           className={cn(
                              'flex items-center h-full text-white font-medium leading-10',
                              {
                                 'text-[#4A5565]': !selectedDay?.enabled,
                              }
                           )}
                        >
                           {day}
                        </p>
                     </Group>
                  </Grid.Col>
                  <Grid.Col span={8}>
                     {selectedDay ? (
                        <TimeRange
                           disabled={!selectedDay?.enabled}
                           value={[selectedDay?.startTime ?? '', selectedDay?.endTime ?? '']}
                           setValue={(value) => {
                              handleTimeSelection(day as TDay, value[0], value[1])
                           }}
                        />
                     ) : (
                        <p className="text-[#4A5565] font-medium leading-10">
                           Off
                        </p>
                     )}
                  </Grid.Col>
                  <Grid.Col span={1}>
                     <Group
                        justify="flex-end"
                        align="center"
                        className="h-full"
                     >
                        <Switch
                           withThumbIndicator={false}
                           checked={!!selectedDay?.enabled}
                           onChange={() => {
                              handleDaySelection(day as TDay)
                           }}
                        />
                     </Group>
                  </Grid.Col>
               </Grid>
            )
         })}
      </Stack>
   )
}
